export const RIGHT_SIDEBAR_WIDTH = 384;
export const MESSAGE_AUDIO_SEEK_ENABLED_DATE = new Date("2026-02-05 00:00:00");
